import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import CompetitorRegular from './competitor-regular-icon.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <CompetitorRegular {...validProps} />;
}
SvgComponent.iconName = 'competitorRegular';

export const CompetitorRegularIcon = svgIconWrapper(SvgComponent);
